import './Home.css'
import {MostPopular,Hero,GamingLibrary} from '../../sections/index'

const Home = () => {
  return (
    <>
   
    <Hero/>
      <MostPopular/>
      <GamingLibrary/>
      </>
  )
  
}

export default Home